module.exports = __webpack_public_path__ + "img/download.94f3d70b.svg";